<ion-header class="form-popup-header">
  <app-header pageName="{{modalHeader??'LOGIN'| translate}}">
    <!-- <ion-buttons end>
      <ion-button
        slot="icon-only"
        fill="clear"
        (click)="onClose()"
        class="ion-padding-left"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons> -->
  </app-header>
</ion-header>

<div class="form-popup-content">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list>
      <ion-item class="ion-margin-end">
        <ion-input type="text" formControlName="cardnum" (ionInput)="onChangeCardNumer($event)"
          placeholder="{{ cardNumberLabel }}">
        </ion-input>

        <ion-icon name="library" size="small" slot="end"></ion-icon>
      </ion-item>
      <!-- <pm-form-validation-messages class="ion-margin-horizontal" [control]="form.controls['email']"> </pm-form-validation-messages> -->

      <ion-item class="ion-margin-end" *ngIf="pinBox">
        <ion-input type="password" formControlName="pin" placeholder="{{ pinNumberLabel }}">
        </ion-input>
        <ion-icon name="lock-closed" class="ion-align-self-center" size="small" slot="end"></ion-icon>
      </ion-item>



      <!-- <pm-form-validation-messages class="ion-margin-horizontal" [control]="form.controls['password']"> </pm-form-validation-messages> -->
    </ion-list>
    <ion-row>
      <ion-col>
        <div class="remember" (click)="rememberMeHandler()">
          <ion-checkbox slot="start" [checked]="rememberMe" [disabled]="disableRememberMe">
          </ion-checkbox>
          <ion-label>{{ 'REMEMBER_ME' | translate }} </ion-label>
        </div>
      </ion-col>


    </ion-row>
    <ion-row class="ion-margin-top">
      <ion-col class="ion-padding">
        <ion-button color="eprintprimary" expand="full" type="submit" [disabled]="!form.valid && !submitted">
          {{ 'SUBMIT' | translate }}
        </ion-button>
      </ion-col>
      <ion-col *ngIf="optionsLength > 1" class="ion-padding">
        <ion-button (click)="onReset()" color="eprintprimary" expand="full">
          {{ 'RESET' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
    <!-- <ion-button color="dark" expand="block" fill="clear" [routerLink]="['/', 'forgot-password']">{{
      'page.login.button.forgotYourPassword'
    }}</ion-button> -->
  </form>
</div>